import c3api from "@/c3api";
import { ref } from "vue";
import { useToast } from "vue-toastification";

export default function useDebug() {
  const isLoading = ref(false);

  const product = ref({});
  const lots = ref([]);
  const lps = ref([]);
  const toast = useToast();

  const fetchProductBySku = async ( params = {} ) => {
    try {
      isLoading.value = true;
      const response = await c3api.get(`/debug/product_by_sku`, { params });
      return (product.value = response.data);
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

  const fetchLotBySku = async (params = {}) => {
    try {
      isLoading.value = true;
      const response = await c3api.get(`/debug/lots_by_sku`, { params });
      return (lots.value = response.data.data);
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

  const fetchSkusByWarehouse = async (params = {}) => {
    try {
      isLoading.value = true;
      const response = await c3api.get(`/debug/skus_by_warehouse`, { params });
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

  const toggleDeleted = async (id, new_value) => {
    try {
      isLoading.value = true;
      const params = { new_value };
      const response = await c3api.post(`/debug/${id}/toggle`, params);
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

  const toggleAllDeleted = async (lp_ids, new_value) => {
    try {
      isLoading.value = true;
      const params = { new_value, lp_ids };
      const response = await c3api.post(`/debug/lps/toggle_all`, params);
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };


  const adjustLot = async (lp_id, params={}) => {
    try {
      isLoading.value = true;
      const response = await c3api.post(`/debug/lps/${lp_id}/adjust_lot`, params);
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

  const adjustExpiry = async (lp_id, params = {}) => {
    try {
      isLoading.value = true;
      const response = await c3api.post(`/debug/lps/${lp_id}/adjust_expiry`, params);
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.data?.join(". "));
    } finally {
      isLoading.value = false;
    }
  };

 

  const batchUpdateLots = async (lp_ids = [], params = {}) => {
   if (!lp_ids.length) return null;
  const { lot_code, edit_reason } = params;
    
    try {
      isLoading.value = true;
      const response = await c3api.post(`/debug/lps/batch_update_lots`, {
        lp_ids,
        lot_code,
        edit_reason,
      });
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      const msg = error.response?.data?.data?.join(". ") || error.message;
      toast.error(`Batch update lots failed: ${msg}`);
    } finally {
      isLoading.value = false;
    }
  };

  const batchUpdateExpiry = async (lp_ids = [], params = {}) => {
    if (!lp_ids.length) return null;
     const { expiry_date, edit_reason } = params;
    try {
      isLoading.value = true;
      const response = await c3api.post(`/debug/lps/batch_update_expiry`, {
        lp_ids,
        expiry_date,
        edit_reason,
      });
      toast.success("Updated successfully.");
      return response.data.data;
    } catch (error) {
      const msg = error.response?.data?.data?.join(". ") || error.message;
      toast.error(`Batch update expiry failed: ${msg}`);
    } finally {
      isLoading.value = false;
    }
  };
  
  return {
    isLoading,
    product,
    lots,
    lps,
    fetchProductBySku,
    fetchLotBySku,
    fetchSkusByWarehouse,
    toggleDeleted,
    toggleAllDeleted,
    adjustLot,
    adjustExpiry,
    batchUpdateLots,
    batchUpdateExpiry,
  };
}
